import { VueConstructor } from 'vue/types/umd'
import StoreAccess, { IStoreAccess } from '@/plugins/StoreAccess'
import {
  MessageOutput,
  ConfirmOutput,
  IConfirmOutputFunc,
  IMessageOutputFunc
} from '@/plugins/MessageOutoput'
import SessionStoreModule, { sessionStore } from '@/store/session/SessionStoreModule'
import ErrorStoreModule, { errorStore } from '@/store/errors/ErrorStoreModule'

export default {
  install(Vue: VueConstructor<Vue>): void {
    Vue.prototype.$tcw = TCardWebPlugins(Vue)
  }
}

export const TCardWebPlugins = (vue: VueConstructor<Vue>): TCardWebPluginsType => {
  return {
    $store: StoreAccess(),
    message: MessageOutput(vue),
    confirm: ConfirmOutput(vue),
    session: sessionStore,
    error: errorStore
  }
}

interface TCardWebPluginsType {
  $store: IStoreAccess
  message: IMessageOutputFunc
  confirm: IConfirmOutputFunc
  session: SessionStoreModule
  error: ErrorStoreModule
}
